<template>
  <div id="main-wrapper" class="show">
    <div class="authincation section-padding">
      <div class="container h-100">
        <div class="row justify-content-center h-100 align-items-center">
          <div class="col-xl-5 col-md-6">
            <auth-header :title="'Sign in to Qash'" />
            <div class="auth-form card">
              <div class="card-body">
                <form
                  method="post"
                  name="myform"
                  class="signin_validate row g-3"
                  action="otp-2"
                  @submit.prevent="onSubmit"
                >
                  <div class="col-12">
                    <input
                      type="email"
                      class="form-control"
                      placeholder="hello@example.com"
                      name="email"
                      v-model="email"
                    />
                  </div>
                  <div class="col-12">
                    <input
                      type="password"
                      class="form-control"
                      placeholder="Password"
                      name="password"
                      v-model="password"
                    />
                  </div>
                  <div class="col-6">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexSwitchCheckDefault"
                        >Remember me</label
                      >
                    </div>
                  </div>
                  <div class="col-6 text-end">
                    <router-link to="reset">Forgot Password?</router-link>
                  </div>
                  <div class="text-center">
                    <button type="submit" class="btn btn-primary btn-block">
                      Sign in
                    </button>
                  </div>
                </form>
                <p class="mt-3 mb-0">
                  Don't have an account?
                  <router-link class="text-primary" to="signup"
                    >Sign up</router-link
                  >
                </p>
              </div>
            </div>
            <div class="privacy-link">
              <router-link to="signup"
                >Have an issue with 2-factor authentication?</router-link
              >
              <br />
              <router-link to="signup">Privacy Policy</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthHeader from "../../components/qCash/AuthHeader.vue";

export default {
  components: { AuthHeader },
  created() {
    this.$auth.logout();
  },
  data() {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    async onSubmit() {
      try {
        const response = await this.$auth.login({
          email: this.email,
          password: this.password
        })
        const data = response;
        console.log('登入成功:', data);
        if (data.data.token) {
          this.$router.push("/otp-2");
        } else {
          this.password = '';
        }
      } catch (error) {
        console.error('登入失敗:', error);
        this.password = '';
      }
    },
  },
};
</script>
